import React from 'react';
import { PersonalBrandAnalyzer } from '../components/brand/PersonalBrandAnalyzer';

export const BrandAnalyzerPage: React.FC = () => {
  return <PersonalBrandAnalyzer />;
};